// extracted by mini-css-extract-plugin
export default {"howWork":"HowIsItWork_howWork__75JSS","punctation":"HowIsItWork_punctation__MWamR","start":"HowIsItWork_start__XgnFn","arrows":"HowIsItWork_arrows__8r05-"};